import { useCallback, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { stringifyWithPath } from '../../../query';
/**
 * 検索フォームを制御するuse
 * @returns {{defaultValue: string, onSubmit: ((function(*): void)|*), inputRef: React.MutableRefObject<undefined>}}
 */
export const useSlideSearchKeyword = () => {
    // 描画コストを削るために、useStateではなくuncontrolledな形でキーワードを制御する
    const inputRef = useRef();
    const { state } = useLocation();
    const history = useNavigate();
    // キーワードの初期値
    const defaultValue = useMemo(() => {
        const { keyword: historyKeyword } = state || {};
        return historyKeyword || '';
    }, [state]);
    /**
     * 検索ページに遷移する
     * @type {(function(*): void)|*}
     */
    const onSubmit = useCallback((e) => {
        e.preventDefault();
        const { value: keyword } = inputRef.current;
        const params = { keyword };
        const url = stringifyWithPath('/proffit_search/search', params);
        history.replace(window.location.pathname, { state: params });
        history.push(url);
    }, [history, inputRef]);
    return {
        defaultValue,
        inputRef,
        onSubmit,
    };
};
export const useSlideSearchCommonSearchKeyword = {
    useSlideSearchKeyword,
};
